import { render, staticRenderFns } from "./DetailsForm.vue?vue&type=template&id=fe23eeaa"
import script from "./DetailsForm.vue?vue&type=script&lang=ts"
export * from "./DetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./DetailsForm.vue?vue&type=style&index=0&id=fe23eeaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports